import { createFetcher } from '../../Fetcher/Fetcher'
import { ADMIN_ENDPOINT, getBaseUrl, PAYMENT_ENDPOINT } from '../../constant'

/**
 * For billing response.
 * @Applications
 */
export default class Payment {
  static getInstance() {
    if (!this.instance) {
      this.instance = new Payment(
        PAYMENT_ENDPOINT,
        ADMIN_ENDPOINT,
        createFetcher()
      )
    }
    return this.instance
  }

  constructor(paymentEndPoint, adminEndPoint, fetcherObj) {
    this.paymentEndPoint = paymentEndPoint
    this.adminEndPoint = adminEndPoint
    this.fetcher = fetcherObj
  }

  static get baseUrl() {
    return getBaseUrl()
  }

  async postPaymentResponse(reqData, resourceId, transactionID) {
    const url = `${Payment.baseUrl + this.adminEndPoint}/${
      resourceId + this.paymentEndPoint
    }/${transactionID}/response`
    const response = await this.fetcher.postData(url, reqData)
    return response?.data?.data
  }
}
